import { gql } from 'apollo-boost';
import { FOLDER_CACHE_SAFE_FIELDS } from '../../fragments/folder/cache-safe-folder-fields';

export const GET_TRASH_FOLDERS_GLOBAL = gql`
    query {
        getTrashFoldersGlobal {
            folders {
                ...FolderCacheSafeFields
                before
                path
                cursor
            }
            cursor
        }
    }
    ${FOLDER_CACHE_SAFE_FIELDS}
`;
